import classNames from 'clsx';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import {
  TXTWCL_PlayedX,
  TXTWCL_PlayingX,
  TXTWCL_RegisteredX__number
} from './RegisteredPlayers.messages.json';
import styles from './RegisteredPlayers.scss';

export type DisplayStatus = 'completed' | 'registered' | 'running' | 'none';

export interface Props {
  numOfPlayers: number;
  status: DisplayStatus;
}

const statusCopy = {
  completed: TXTWCL_PlayedX,
  registered: TXTWCL_RegisteredX__number,
  running: TXTWCL_PlayingX
};

const RegisteredPlayers: React.FC<Props> = ({ numOfPlayers, status }) =>
  status !== 'none' ? (
    <div className={styles.playStatus}>
      <div className={classNames(styles.oval, styles[status])} />
      <Translation {...statusCopy[status]} />
      <span className={styles.players}>{numOfPlayers}</span>
    </div>
  ) : null;

export default RegisteredPlayers;
